'use strict';

var importScript = function(src) {
  var script = document.createElement('script');

  script.setAttribute('src', src);
  script.type = 'text/javascript';
  script.defer = true;
  script.async = true;

  return new Promise(function(resolve, reject) {
    script.onload = resolve;
    script.onerror = reject;

    document.head.appendChild(script);
  });
};

module.exports = {
  importScript: importScript
};
